import type { TPlayer } from '@setplex/pureya'

/**
 * Fallback text used when upstream did not provide program metadata.
 */
export const NO_PROGRAM_DATA = 'No Program Data'

/**
 * MQ payload signaling that a concrete player instance was mounted/unmounted
 * in React tree and is eligible for analytics.
 */
export class PlayerMountedMessage {
  static readonly topic = 'app/player/mounted'
  public player: TPlayer
  public mounted: boolean

  constructor(player: TPlayer, mounted: boolean) {
    this.player = player
    this.mounted = mounted
  }
}

export type PlayerMeta = {
  id: string
  type: 'tv' | 'vod' | 'tvshow' | 'catchup' | 'event'
  url?: string
  name?: string
  program?: string
  paid: boolean
  trailer: boolean
  trailerCategoryName?: string
}

/**
 * MQ payload carrying normalized content metadata for currently active player.
 */
export class PlayerMetaMessage {
  static readonly topic = 'app/player/meta'
  public meta: PlayerMeta

  constructor(meta: PlayerMeta) {
    this.meta = meta
    if (meta.program == null) {
      meta.program = NO_PROGRAM_DATA
    }
  }
}
